export default __webpack_public_path__ + "static/media/signature.3682faa1.webp";